import { useCallback, useContext, useMemo } from "react";
import {
    IRegisterFromCPFNumberRequest,
    IRegisterFromCPFUserRequest,
    ISessionResponse,
} from "@finbackoffice/clientbff-client";
import { ClientBFFContext } from "../../providers";
import { CpfSignupContext } from "./cpf-signup.provider";

export const useSecondStepSignup = () => {
    const client = useContext(ClientBFFContext);
    const { setStep, newRegisterUser, setNewRegisterUser } = useContext(CpfSignupContext);

    const registerCPFUser = useCallback(
        async (data: IRegisterFromCPFUserRequest | IRegisterFromCPFNumberRequest) => {
            let response = {} as ISessionResponse;
            if (newRegisterUser?.id) {
                response = await client.registerFromCPFNumber({
                    ...data,
                    cpf_number: newRegisterUser?.cpf_number || "",
                });
                setNewRegisterUser({ ...newRegisterUser, token: response.token });
            } else {
                response = await client.registerFromCPFUser(data);
                setNewRegisterUser({ ...data, token: response.token });
            }
            setStep("complete");
        },
        [setStep, client, newRegisterUser, setNewRegisterUser],
    );

    return useMemo(
        () => ({
            registerCPFUser,
        }),
        [registerCPFUser],
    );
};
